import artCard from '../assets/bill_card.png';
import artBbps from '../assets/bill_bbps.png';
import Copy from './Copy';
import Cta, { ctaProps } from './Cta';

/* Artwork per API card `type`. Each export has different transparent padding,
   so the crop class (and the gap to the copy) differs per card. */
const ART = {
  CREDIT_CARD: { src: artCard, className: 'bbd-bill-art-card' },
  BBPS: { src: artBbps, className: 'bbd-bill-art-bbps' },
};

function BillCard({ card, onAction }) {
  const art = ART[card.type] || ART.BBPS;
  return (
    <div className="bbd-bill-card">
      <div className={'bbd-bill-art ' + art.className}>
        <img src={art.src} alt="" />
      </div>
      <p><Copy text={card.text} highlight={card.highlight} /></p>
      <Cta small {...ctaProps(card.cta, onAction)} />
    </div>
  );
}

/* "Pay Your Bills & Earn" — one card per entry in the API `bills.cards`
   (credit card repayment and BBPS). */
export default function BillsSection({ data, onAction }) {
  return (
    <section className="bbd-bills">
      <h2 className="bbd-bills-title">{data.title}</h2>

      {(data.cards || []).map((card, i) => (
        <BillCard key={card.type || i} card={card} onAction={onAction} />
      ))}
    </section>
  );
}
